import { ReactNode, useEffect, useRef, useState } from "react";
import { useRecoilValue } from "recoil";
import { message, Spin } from "antd";
import { useHistory } from "react-router-dom";
import { UserAtom } from "../../store";
import { checkPermissions } from "../../utils/checkPermissions";

type PermissionDirectProps = {
  screen: string[];
  moreCondition?: boolean;
  action?: string;
  children: ReactNode;
};

export const PermissionDirect = (
  PermissionDirectProps: PermissionDirectProps,
) => {
  //Define constant
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const permissionState = useRecoilValue<any>(UserAtom.permissions);
  const features = permissionState?.features;
  const [messageApi, contextHolder] = message.useMessage();
  const screenKey = PermissionDirectProps.screen.join("|");
  const action = PermissionDirectProps.action || "view";
  const isHydrated = Boolean(features);
  const isAuthorized =
    isHydrated &&
    PermissionDirectProps.screen.some((item) =>
      checkPermissions(item, action, features),
    );


  //Function to effect
  useEffect(() => {
    setLoading(true);

    if (!isHydrated) {
      return;
    }

    if (!isAuthorized) {
      messageApi.error("Bạn không có quyền xem dữ liệu này");
      const redirectTimeout = window.setTimeout(() => {
        history.push("/operation");
      }, 1500);

      return () => {
        window.clearTimeout(redirectTimeout);
      };
    }

    setLoading(false);
  }, [
    action,
    features,
    history,
    isAuthorized,
    isHydrated,
    messageApi,
    screenKey,
  ]);

  if (
    !isHydrated ||
    !isAuthorized ||
    loading ||
    PermissionDirectProps.moreCondition
  ) {
    return (
      <>
        {contextHolder}
        <Spin size="large" />;
      </>
    );
  }

  return (
    <>
      {contextHolder}
      {PermissionDirectProps.children}
    </>
  );
};
